import React from 'react';
import PropTypes from 'prop-types';
import IconToolCardRoutesLg from '~/router/IconToolCardRoutesLg';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function ContentSwitcher_Lg(props) {
  return <IconToolCardRoutesLg {...props} />;
}

ContentSwitcher_Lg.displayName = 'ContentSwitcher_Lg';

const propTypes = {
  isFundraisingMode: PropTypes.bool,
  slideOver: PropTypes.bool
};

ContentSwitcher_Lg.propTypes = propTypes;
